import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Checkbox from "@mui/material/Checkbox";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import AuthLayout from "views/layouts/AuthLayout";

// Images
import rocket from "assets/images/illustrations/rocket-white.png";

import Apiservice from "services/ApiService";
import ToastUtils from "utils/ToastUtils";
import ValidationService from "services/ValidationService";
import _ from "lodash";

function Register() {
  const [agreement, setAgreemnet] = useState(false);
  const [registerBtnDisabled, setRegisterBtnDisabled] = useState(true);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [phone, setPhone] = useState("");
  const [verifyPass, setVerifyPass] = useState("");
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const navigate = useNavigate();

  const handleSetAgremment = () => {
    setAgreemnet(!agreement);
    setRegisterBtnDisabled(agreement);
  };
  const handleSetName = (e) => {
    setFirstNameError(false);
    setName(e.target.value);
  };
  const handleSetSurname = (e) => {
    setLastNameError(false);
    setSurname(e.target.value);
  };
  const handleSetEmail = (e) => {
    setEmailError(false);
    setEmail(e.target.value);
  };
  const handleSetPassword = (e) => {
    setPasswordError(false);
    setPass(e.target.value);
  };
  const handleSetVerifyPassowrd = (e) => {
    setPasswordError(false);
    setVerifyPass(e.target.value);
  };
  const handleSetPhone = (e) => {
    setPhoneError(false);
    setPhone(e.target.value);
  };
  const handleRegister = async () => {
    setRegisterBtnDisabled(true);

    const registration = {
      firstName: name,
      lastName: surname,
      email: email,
      phone: phone,
      password: pass,
      confirmPassword: verifyPass,
    };
    const error = ValidationService.validateUser(registration);
    if (error) {
      handleValidationError(error);
      setRegisterBtnDisabled(false);
      return;
    }
    setRegisterBtnDisabled(true);
    const response = await Apiservice.postData("/api/v1/users/register", registration);
    setRegisterBtnDisabled(false);

    if (!response) {
      ToastUtils.error("Αδυναμία δημιουργίας χρήστη!");
      return;
    }
    ToastUtils.success("Ο χρήστης δημηιουργήθηκε με επιτυχία!");
    navigate("/login");
  };

  const handleValidationError = (error) => {
    let pathName = _.get(error, "details[0].path[0]");
    console.log(error);
    switch (pathName) {
      case "firstName":
        setFirstNameError(true);
        return;
      case "lastName":
        setLastNameError(true);
        return;
      case "email":
        setEmailError(true);
        return;
      case "phone":
        setPhoneError(true);
        return;
      case "password":
        setPasswordError(true);
        return;
      case "confirmPassword":
        setPasswordError(true);
        return;
      default:
        ToastUtils.error("Αδυναμία επαλήθευσης στοιχείων!");
    }
  };

  return (
    <AuthLayout
      title="Δημιουργία Λογαριασμού"
      description="Συμπληρώστε τα απαραίτητα στοιχεία για τη δημιουργία λογαριασμού. Για τα στοιχεία θα απαιτηθεί επιβεβαίωση."
      illustration={{
        image: rocket,
        title: "Το ταξίδι στην ηλεκτρονική τιμολόγηση ξεκινάει εδώ!",
        description: "",
      }}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftInput
            placeholder="Όνομα"
            size="large"
            onChange={handleSetName}
            error={firstNameError}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            placeholder="Επώνυμο"
            size="large"
            onChange={handleSetSurname}
            error={lastNameError}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            type="email"
            placeholder="Email"
            size="large"
            onChange={handleSetEmail}
            error={emailError}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            placeholder="Κινητό τηλέφωνο"
            size="large"
            onChange={handleSetPhone}
            error={phoneError}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            type="password"
            placeholder="Κωδικός"
            size="large"
            onChange={handleSetPassword}
            error={passwordError}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            type="password"
            placeholder="Επιβεβαίωηση κωδικού"
            size="large"
            onChange={handleSetVerifyPassowrd}
            error={passwordError}
          />
        </SoftBox>
        <SoftBox display="flex" alignItems="center">
          <Checkbox checked={agreement} onChange={handleSetAgremment} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetAgremment}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Διάβασα και αποδέχομαι την&nbsp;
          </SoftTypography>
          <SoftTypography component="a" href="#" variant="button" fontWeight="bold" textGradient>
            Πολιτική Απορρήτου
          </SoftTypography>
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton
            variant="gradient"
            color="info"
            size="large"
            fullWidth
            disabled={registerBtnDisabled}
            onClick={handleRegister}
          >
            ΕΓΓΡΑΦΗ
          </SoftButton>
        </SoftBox>
        <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Έχετε ήδη λογαριασμό?&nbsp;
            <SoftTypography
              component={Link}
              to="/login"
              variant="button"
              color="info"
              fontWeight="bold"
              textGradient
            >
              Σύνδεση
            </SoftTypography>
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    </AuthLayout>
  );
}

export default Register;
